module.exports = __webpack_public_path__ + "static/img/timer.cc8364d7.png";